import { getInvitationsScheduledStatus, getReviewSources } from "../api";

export type AutomationStatus = {
  hasAutomationEnabled: boolean;
  hasScheduledInvitesFromAutomatedSourcesInPast28Days: boolean;
};

export const getAutomationStatus = async (businessUnitId: string, locale: string): Promise<AutomationStatus> => {
  const defaultReturn: AutomationStatus = {
    hasAutomationEnabled: false,
    hasScheduledInvitesFromAutomatedSourcesInPast28Days: false,
  };
  try {
    const [invitationsScheduledStatusResponse, reviewSourcesResponse] = await Promise.all([
      getInvitationsScheduledStatus(businessUnitId),
      getReviewSources(locale),
    ]);

    const automaticReviewSources = reviewSourcesResponse
      .filter((x) => x.sourceGroup.id === "automatic-invitation")
      .map((x) => x.name.toLowerCase());

    const lastScheduledInvitations =
      invitationsScheduledStatusResponse.invitationsMethodsLastScheduledInvitations || {};

    const invitationsScheduledStatus = Object.entries(lastScheduledInvitations).map(([key, value]) => ({
      source: key.toLowerCase(),
      time: new Date(value),
      automatic: automaticReviewSources.includes(key.toLowerCase()),
    }));

    const hasAutomationEnabled = invitationsScheduledStatus.some((x) => x.automatic);

    if (!hasAutomationEnabled) {
      return { hasAutomationEnabled, hasScheduledInvitesFromAutomatedSourcesInPast28Days: false };
    }

    const time28daysAgo = new Date().getTime() - 28 * 24 * 60 * 60 * 1000;
    const hasScheduledInvitesFromAutomatedSourcesInPast28Days = invitationsScheduledStatus.some(
      (x) => x.automatic && x.time.getTime() > time28daysAgo,
    );

    return {
      hasAutomationEnabled,
      hasScheduledInvitesFromAutomatedSourcesInPast28Days,
    };
  } catch (e) {
    return defaultReturn;
  }
};
